import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '@/assets/img/bobbee_hrz.png'


const _hoisted_1 = { class: "d-flex bg_auth" }
const _hoisted_2 = { class: "d-flex flex-row justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_companyLogoView = _resolveComponent("companyLogoView")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_ossPdf = _resolveComponent("ossPdf")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_resumeView = _resolveComponent("resumeView")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, {
      "no-gutters": "",
      dense: "",
      class: "d-flex"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          class: "d-flex justify-center",
          cols: _ctx.$vuetify.display.mobile ? 12 : 3
        }, {
          default: _withCtx(() => [
            (_ctx.companyId)
              ? (_openBlock(), _createBlock(_component_companyLogoView, {
                  key: 0,
                  companyId: _ctx.companyId,
                  cssStyle: "height: 50px;"
                }, null, 8, ["companyId"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["cols"]),
        _createVNode(_component_v_col, {
          cols: _ctx.$vuetify.display.mobile ? 12 : 6
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_tabs, {
              "show-arrows": "",
              "align-tabs": "center",
              "center-active": "",
              modelValue: _ctx.documentIterator,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.documentIterator) = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayDocuments, (document) => {
                  return (_openBlock(), _createBlock(_component_v_tab, {
                    key: document.documentId
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(document.title), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_v_window, {
              modelValue: _ctx.documentIterator,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.documentIterator) = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (document) => {
                  return (_openBlock(), _createBlock(_component_v_window_item, {
                    class: "mt-4",
                    key: document.documentId
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ossPdf, {
                        style: {"max-height":"92vh","max-width":"100vw","overflow-y":"auto","overflow-x":"hidden"},
                        signedUrl: document.signedUrl
                      }, null, 8, ["signedUrl"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["cols"]),
        _createVNode(_component_v_col, {
          cols: _ctx.$vuetify.display.mobile ? 12 : 3,
          class: "d-flex flex-column justify-space-between"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_resumeView, {
              type: _ctx.type,
              invoices: _ctx.documents,
              data: _ctx.data,
              documentSignedUrl: _ctx.documentSignedUrl,
              class: "mr-4 ml-4 mt-16"
            }, null, 8, ["type", "invoices", "data", "documentSignedUrl"]),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_img, {
                src: _imports_0,
                "max-height": 30,
                "max-width": 149,
                class: "mr-4 mb-4"
              })
            ])
          ]),
          _: 1
        }, 8, ["cols"])
      ]),
      _: 1
    })
  ]))
}